import '/assets/styles/partials/checkout-section.scss';
import classNames from 'classnames';

const CheckoutSection = ({ title, className, contentClassName, children, narrow }) => {
	return (
		<div className={classNames('checkoutsection', className, { narrow })}>
			{title && <div className="checkoutsection-title">{title}</div>}

			<div className={classNames('checkoutsection-content', contentClassName)}>{children}</div>
		</div>
	);
};

export default CheckoutSection;
